<template>
  <div class="header_container">
    <div
      class="logo_container flex-row"
      @click="toCourses"
    >
      <img
        class="logo_image"
        referrerpolicy="no-referrer"
        :src="
          domainName == '灵智鸟'
            ? require('@/assets/public/logo48.png')
            : require('@/assets/public/logo48-2.png')
        "
      />
      <span class="logo_text">{{ domainName }}</span>
    </div>
    <div
      class="header_info_container flex-row justify-right"
      @click="showUser = true"
    >
      <span class="school_name">{{ schoolName }}</span>
      <span class="user_nickname">{{ nickName }}</span>
    </div>
  </div>
  <div
    class="user_container"
    v-show="showUser"
  >
    <div
      class="user_info_left"
      @click="showUser = false"
    ></div>
    <div class="user_info_container">
      <img
        class="user_avatar"
        referrerpolicy="no-referrer"
        :src="
          require('@/assets/student/user/FigmaDDSSlicePNG9b34a05026f2ec932dadf95d02cfad49.png')
        "
      />
      <div class="user_info flex-col justify-between">
        <span class="user_text">UID：{{ userId }}</span>
        <span class="user_text">{{ userName }}</span>
        <span
          class="reset_password"
          @click="handleOpenPasswordDialog"
          >更改密码</span
        >
      </div>
      <div
        class="user_logout_container"
        @click="handleLogout"
      >
        <span class="user_logout_text">登出</span>
      </div>
    </div>
  </div>
  <PasswordChangeDialog
    :visible="showPasswordDialog"
    @close="handleClosePasswordDialog"
    @confirm="handlePasswordConfirm"
  />
</template>

<script setup>
import { ref, onMounted, computed } from "vue"
import { useRouter } from "vue-router"

import alovaInstance from "@/utils/alova"
import PasswordChangeDialog from "@/components/dialog/PasswordChangeDialog.vue"

import { getDomainName } from "@/utils/domainConfig"

// 根据域名获取配置
const domainName = computed(() => getDomainName())

const router = useRouter()
const showUser = ref(false)
const schoolName = ref("某中小学")
const nickName = ref("老师")
const userId = ref("")
const userName = ref("姓名")
const showPasswordDialog = ref(false)

const handleOpenPasswordDialog = () => {
  showPasswordDialog.value = true
}

const handleClosePasswordDialog = () => {
  showPasswordDialog.value = false
}

const handlePasswordConfirm = async (passwordData) => {
  try {
    const response = await alovaInstance.Post(
      "/Teacher/ModifyPassword",
      passwordData
    )
    if (response.code === 1000) {
      alert("密码修改成功")
      handleClosePasswordDialog()
    } else {
      alert(response.message || "密码修改失败")
    }
  } catch (error) {
    console.error("密码修改请求失败:", error)
    alert("网络错误，请稍后重试")
  }
}

onMounted(async () => {
  try {
    let response = await alovaInstance.Post("/Teacher/TeacherInfo")
    if (response.code === 1000) {
      // console.log(response.data)
      userId.value = response.data.id
      schoolName.value = response.data.schoolName
      nickName.value = response.data.nickName
      userName.value = response.data.teacherName
    } else {
      alert("获取信息失败")
    }
  } catch (error) {
    console.error("登录失败:", error)
    alert("获取失败，请稍后重试")
  }
})

const toCourses = () => {
  router.push({
    name: "TeacherCourses",
  })
}

const handleLogout = () => {
  // localStorage.removeItem("jwt_token")
  router.push("/teacher/login")
}
</script>

<style scoped>
.header_container {
  background-color: rgba(255, 255, 255, 1);
  width: 100vw;
  height: 2.87vw;
}

.logo_container {
  position: absolute;
  top: 0;
  left: 0;
  cursor: pointer;
}

.logo_image {
  width: 2.09vw;
  height: 2.09vw;
  margin: 0.4vw 0 0 2.91vw;
}

.logo_text {
  width: 3.75vw;
  height: 1.57vw;
  overflow-wrap: break-word;
  color: rgba(34, 76, 123, 1);
  font-size: 1.25vw;
  font-family: Microsoft YaHei UI-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 1.25vw;
  margin: 0.8vw 0 0 0.83vw;
}

.header_info_container {
  position: absolute;
  top: 0;
  right: 0;
  cursor: pointer;
}

.header_info_container:hover {
  opacity: 0.8;
}

.school_name {
  width: auto;
  height: 1.52vw;
  overflow-wrap: break-word;
  color: rgba(104, 162, 250, 1);
  font-size: 1.25vw;
  font-family: Inter-Regular;
  font-weight: normal;
  text-align: right;
  white-space: nowrap;
  line-height: 1.25vw;
  margin: 0.8vw 1vw 0 0;
}

.user_nickname {
  width: auto;
  min-width: 2.5w;
  height: 1.67vw;
  overflow-wrap: break-word;
  color: rgba(55, 91, 165, 1);
  font-size: 1.25vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: right;
  white-space: nowrap;
  line-height: 1.25vw;
  margin: 0.8vw 1.5vw 0 0;
}

.user_container {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 999;
}

.user_info_left {
  position: absolute;
  left: 0;
  top: 0;
  width: calc(100% - 20vw);
  height: 100%;
  background-color: rgba(33, 57, 82, 0.8);
}

.user_info_container {
  position: absolute;
  right: 0;
  top: 0;
  background-color: rgba(247, 251, 255, 1);
  width: 20vw;
  height: 56.25vw;
  margin-left: 80vw;
}

.user_avatar {
  width: 7.19vw;
  height: 7.19vw;
  margin: 5.78vw 0 0 6.87vw;
}

.user_text {
  width: 18vw;
  height: 1.67vw;
  overflow-wrap: break-word;
  color: rgba(44, 48, 52, 1);
  font-size: 1.25vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: center;
  white-space: nowrap;
  line-height: 1.67vw;
  margin: 0.78vw 0 0 1.4vw;
}

.reset_password {
  width: 18vw;
  height: 1.67vw;
  overflow-wrap: break-word;
  color: rgba(44, 48, 52, 1);
  font-size: 1.4vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: center;
  white-space: nowrap;
  line-height: 1.67vw;
  margin: 1.2vw 0 0 1.4vw;
  cursor: pointer;
}

.reset_password:hover {
  color: rgba(110, 110, 110, 1);
}

.user_logout_container {
  background-color: rgba(243, 171, 69, 1);
  border-radius: 4px;
  height: 2.71vw;
  width: 17.2vw;
  margin: 20.83vw 0 2.55vw 1.4vw;
  cursor: pointer;
}

.user_logout_text {
  width: 2vw;
  height: 1.05vw;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 1.04vw;
  font-family: Segoe UI-Semibold;
  font-weight: 600;
  text-align: left;
  white-space: nowrap;
  line-height: 2.71vw;
  margin: 0.78vw 0 0 7.55vw;
}
</style>
